import React from "react";
import { Theme, makeStyles } from "@material-ui/core/styles";
import {
  Grid,
  // Typography, Button
} from "@material-ui/core";
// import { AddPhotoAlternateRounded } from "@material-ui/icons";
import clsx from "clsx";
import TextLabel from "../components/draw-tools/text-label";
import Measure from "../components/draw-tools/measure";
import ImportCad from "../components/draw-tools/import-cad";
import SelectAnno from "../components/draw-tools/select-anno";
import DrawingShape from "../components/draw-tools/drawing-shape";
import ScaleMap from "../components/draw-tools/scale-map";
import ExportData from "../components/draw-tools/export-data";

const useStyle = makeStyles((theme: Theme) => ({
  container: { padding: theme.spacing(1) },
  gridFlex: { display: "flex" },
  default: { color: theme.palette.secondary.main },
  spaceInGroup: {
    marginLeft: theme.spacing(0.5),
  },
  flexMiddle: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
  },
  btnSelect: {
    boxShadow: "unset",
    padding: theme.spacing(0.3),
    width: theme.spacing(4),
    height: theme.spacing(4),
    fontFamily: ["Montserrat-Bold", "Kanit-Bold"].join(","),
    minWidth: "unset",
  },
}));

const DrawingTools = () => {
  const classes = useStyle();

  return (
    <div className={classes.container}>
      <Grid container spacing={1}>
        <Grid item className={classes.gridFlex}>
          <TextLabel />
        </Grid>
        <Grid item className={clsx(classes.gridFlex)}>
          <DrawingShape />
        </Grid>
        <Grid item className={clsx(classes.gridFlex)}>
          <SelectAnno />
        </Grid>
        <Grid item className={clsx(classes.gridFlex)}>
          <ScaleMap />
        </Grid>
        <Grid item className={clsx(classes.gridFlex)}>
          <Measure />
        </Grid>
        <Grid item className={clsx(classes.gridFlex)}>
          <ImportCad />
        </Grid>
        <Grid item className={clsx(classes.gridFlex)}>
          <ExportData />
        </Grid>

        {/* <Grid item className={clsx(classes.gridFlex)}>
          <Typography variant="subtitle2" className={clsx(classes.flexMiddle)}>
            Image:
          </Typography>
          <Button
            variant="outlined"
            size="small"
            className={clsx(classes.btnSelect, classes.spaceInGroup)}
          >
            <AddPhotoAlternateRounded className={clsx(classes.default)} />
          </Button>
        </Grid> */}
      </Grid>
    </div>
  );
};

export default DrawingTools;
